export default {
  //----------------------------------------------------------------------------------------
  platform: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/platform/index.vue'));
    }, '/modules/platform/index');
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/platform.js